/* Elpheco Sonic — theme scripts (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || { routes: {}, strings: {} };
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  if (designMode) document.body.classList.add('shopify-design-mode');

  /* ---------- Header: scrolled state, search, mobile menu ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
      var top = $('[data-back-to-top]');
      if (top) top.classList.toggle('is-visible', window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var overlay = $('[data-search-overlay]');
    $$('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!overlay) return;
        e.preventDefault();
        overlay.hidden = false;
        var input = $('input[type="search"]', overlay);
        if (input) setTimeout(function () { input.focus(); }, 30);
      });
    });
    $$('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { overlay.hidden = true; });
    });

    var menu = $('[data-mobile-menu]');
    var toggle = $('[data-menu-toggle]');
    var setMenu = function (open) {
      if (!menu) return;
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    if (toggle) toggle.addEventListener('click', function () { setMenu(true); });
    $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
    if (menu) menu.addEventListener('click', function (e) { if (e.target === menu) setMenu(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      setMenu(false);
      if (overlay) overlay.hidden = true;
      closeCart();
    });

    var top = $('[data-back-to-top]');
    if (top) top.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(ctx) {
    var items = $$('.reveal:not(.is-visible), [data-swirl]:not(.is-visible)', ctx);
    if (!('IntersectionObserver' in window) || designMode) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Swirl gallery parallax ---------- */
  function initSwirl() {
    var swirls = $$('[data-swirl]');
    if (!swirls.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var ticking = false;
    var update = function () {
      ticking = false;
      if (window.innerWidth < 900) return;
      swirls.forEach(function (swirl) {
        var rect = swirl.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        var progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        $$('.swirl__item[data-depth]', swirl).forEach(function (item) {
          var depth = parseFloat(item.getAttribute('data-depth')) || 0.5;
          item.style.setProperty('--shift', (progress * depth * -160).toFixed(1) + 'px');
        });
      });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Hero: smooth scroll to video ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var video = $('video', target);
      if (video) { video.muted = false; video.controls = true; try { video.play(); } catch (err) {} }
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty(ctx) {
    $$('[data-qty]', ctx).forEach(function (wrap) {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = $('input', wrap);
      var change = function (d) {
        var min = parseInt(input.min || '0', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + d);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      var minus = $('[data-qty-minus]', wrap), plus = $('[data-qty-plus]', wrap);
      if (minus) minus.addEventListener('click', function () { change(-1); });
      if (plus) plus.addEventListener('click', function () { change(1); });
    });
    $$('[data-autosubmit]', ctx).forEach(function (input) {
      if (input.dataset.boundSubmit) return;
      input.dataset.boundSubmit = '1';
      var t;
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () { input.form && input.form.submit(); }, 500);
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer;
  function openCart() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) { window.location.href = theme.routes.cart; return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function renderCart(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-cart-drawer]', html);
      var current = $('[data-cart-drawer]');
      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) current.classList.add('is-open');
      }
    }
  }
  function updateCount() {
    return fetch(theme.routes.root.replace(/\/$/, '') + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
        return cart;
      });
  }
  function changeLine(line, quantity) {
    var d = $('[data-cart-drawer]');
    if (d) d.classList.add('is-loading');
    return fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { renderCart(res.sections); return updateCount(); })
      .finally(function () { var dd = $('[data-cart-drawer]'); if (dd) dd.classList.remove('is-loading'); });
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle && theme.cartType === 'drawer' && $('[data-cart-drawer]')) {
        e.preventDefault();
        openCart();
        return;
      }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      var q = e.target.closest('[data-qty-change]');
      if (q && q.closest('[data-cart-drawer]')) {
        var line = q.closest('[data-line]');
        changeLine(parseInt(line.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-qty-change'), 10));
      }
    });
  }

  /* ---------- Product: variants, gallery, add to cart ---------- */
  function formatMoney(cents) {
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, withComma);
  }

  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var gallery = $('[data-gallery]', section);

    // Gallery
    var showMedia = function (id) {
      if (!gallery || !id) return;
      $$('.product__slide', gallery).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
      $$('[data-thumb]', gallery).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    };
    if (gallery) {
      $$('[data-thumb]', gallery).forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
      });
      var step = function (dir) {
        var slides = $$('.product__slide', gallery);
        var i = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = slides[(i + dir + slides.length) % slides.length];
        if (next) showMedia(next.getAttribute('data-media-id'));
      };
      var prev = $('[data-gallery-prev]', gallery), nxt = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (nxt) nxt.addEventListener('click', function () { step(1); });
      // swipe
      var startX = null;
      var stage = $('.product__stage', gallery);
      if (stage) {
        stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
          startX = null;
        });
      }
    }

    if (!form) return;
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var priceWrap = $('[data-product-price]', section);
    var stock = $('[data-stock]', form);
    var errorEl = $('[data-form-error]', form);

    var currentOptions = function () {
      return $$('.option-picker', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    };
    var markAvailability = function (opts) {
      $$('.option-picker', form).forEach(function (fs, idx) {
        $$('.option-pill', fs).forEach(function (pill) {
          var val = $('input', pill).value;
          var test = opts.slice(); test[idx] = val;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    };
    var update = function () {
      var opts = currentOptions();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      $$('.option-picker', form).forEach(function (fs, idx) {
        var lbl = $('[data-option-selected]', fs);
        if (lbl) lbl.textContent = opts[idx] || '';
      });
      markAvailability(opts);
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = theme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (stock) stock.innerHTML = variant.available
        ? '<span class="dot dot--ok"></span> ' + (stock.getAttribute('data-in') || stock.textContent.trim())
        : '<span class="dot"></span> ' + theme.strings.soldOut;
      if (priceWrap) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        var html = '<div class="price' + (onSale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(variant.price) + '</span>' +
          (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') + '</div>' +
          (onSale ? '<span class="badge">-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%</span>' : '');
        priceWrap.innerHTML = html;
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (!designMode && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };
    if (stock && !stock.getAttribute('data-in')) stock.setAttribute('data-in', stock.textContent.trim());
    $$('.option-picker input', form).forEach(function (input) { input.addEventListener('change', update); });
    if ($$('.option-picker', form).length) markAvailability(currentOptions());

    form.addEventListener('submit', function (e) {
      if (theme.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      addBtn.classList.add('is-loading');
      addLabel.textContent = theme.strings.adding;
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      fetch(theme.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Error');
          renderCart(res.body.sections);
          return updateCount().then(function () {
            addLabel.textContent = theme.strings.added;
            openCart();
          });
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () {
          addBtn.classList.remove('is-loading');
          setTimeout(function () { if (!addBtn.disabled) addLabel.textContent = theme.strings.addToCart; }, 1200);
        });
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length && $('.product-grid', el)) return;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fresh = $('[data-recommendations]', html);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initReveal(el); }
      });
    });
  }

  /* ---------- Collection filters / sort ---------- */
  function initFilters() {
    $$('[data-collection-filters]').forEach(function (form) {
      var submit = function () {
        var params = new URLSearchParams(new FormData(form));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        window.location.search = params.toString();
      };
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        submit();
      });
      $$('input[type="number"]', form).forEach(function (i) {
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
        i.addEventListener('blur', submit);
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      // close other dropdowns
      $$('details.filter', form).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) $$('details.filter', form).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
    document.addEventListener('click', function (e) {
      $$('details.filter[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }

  /* ---------- FAQ: three-column layout on desktop, accordion on mobile ---------- */
  function initFaq() {
    var items = $$('.faq__item');
    if (!items.length) return;
    var mq = window.matchMedia('(min-width: 960px)');
    var apply = function () {
      items.forEach(function (d, i) { d.open = mq.matches ? true : i === 0; });
    };
    items.forEach(function (d) {
      $('summary', d).addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
    });
    mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
    apply();
  }

  /* ---------- Customer login: recover password toggle ---------- */
  function initRecover() {
    var login = $('[data-login-panel]'), recover = $('[data-recover-panel]');
    if (!login || !recover) return;
    var show = function (r) { recover.hidden = !r; login.hidden = r; };
    $$('[data-recover-toggle]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); show(recover.hidden); });
    });
    if (window.location.hash === '#recover') show(true);
  }

  /* ---------- Boot ---------- */
  function boot() {
    initHeader();
    initAnchors();
    initReveal();
    initSwirl();
    initQty();
    initCart();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
    initFilters();
    initFaq();
    initRecover();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor: re-init a section when it is re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initQty(e.target);
    $$('[data-product-section]', e.target).forEach(initProduct);
    if ($('[data-swirl]', e.target)) initSwirl();
    initFaq();
  });
})();
